define('StockStatusTags.View',
  [
    'SCView',
    'stock_status_tags.tpl'
  ],
  function (
    SCViewComponent,
    stockStatusTagsTpl
  ) {
    'use strict';

    var SCView = SCViewComponent.SCView;

    function StockStatusTagsView(options) {
      SCView.call(this, arguments);
      this.options = options;
      this.template = stockStatusTagsTpl;
      this.buildItemTags = options.buildItemTags;

      var item = options.model && options.model.get ? options.model.get('item') : null;
      var itemData = item && item.toJSON ? item.toJSON() : item;

      this.tags = itemData && this.buildItemTags ? this.buildItemTags(itemData) : [];
    }

    StockStatusTagsView.prototype = Object.create(SCView.prototype);
    StockStatusTagsView.prototype.constructor = StockStatusTagsView;

    StockStatusTagsView.prototype.getContext = function () {
      return {
        tags: this.tags,
        showStockStatusTags: this.tags.length > 0
      };
    };

    return StockStatusTagsView;
  }
);
